'use client';

import { AD_PLACEMENTS } from './adPlacements';
import { NativeAdSlot } from './NativeAdSlot';

//* my-16: 광고 프레임 자체에 상하 여백을 준다(슬롯이 빈 광고면 NativeAdSlot이 null을 반환하므로 팬텀 갭 없음).
export const BenefitHomeTopNativeAd = () => (
  <NativeAdSlot
    {...AD_PLACEMENTS.benefitHomeTopNative}
    className="my-16 xl:hidden"
  />
);
